export default __webpack_public_path__ + "static/media/Black Pharaoh's Soul Blade.10a3fc38.jpg";